import { Component, Input, OnInit } from '@angular/core';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { ResponseResult } from 'src/app/@core/models/response.model';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { TeamMemberModel } from 'src/app/shared/models/team-member.model';
import { TeamMembersService } from 'src/app/shared/services/team-members.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.scss'],
})
export class OurTeamComponent implements OnInit {
  @Input() data: TeamMemberModel;
  isRtl: boolean = true;
  personResource = environment.userResource;
  /** The request has come back - used to tell "loading" from "nothing published". */
  loaded: boolean = false;

  constructor(
    private teamMemberService: TeamMembersService,
    private langService: LanguageService,
    private identityService: IdentityService
  ) {}

  /** Unified Code mode renders a visible page title (Custom mode keeps the page without one). */
  get isUnified(): boolean {
    return this.identityService.isUnifiedCode();
  }

  filter: FilterModel = new FilterModel(1, 10);
  result: ResponseResult<Array<TeamMemberModel>> = new ResponseResult<
    Array<TeamMemberModel>
  >();

  ngOnInit(): void {
    this.isRtl = this.langService.getCurrentLanguage() === LanguageEnum.ar;
    this.langService.languageChange.subscribe((result: LanguageEnum) => {
      this.isRtl = result === LanguageEnum.ar;
    });

    this.teamMemberService
      .getPaging(this.filter)
      .subscribe({
        next: (result: ResponseResult<Array<TeamMemberModel>>) =>
          (this.result = result),
        error: () => (this.loaded = true),
        complete: () => (this.loaded = true),
      });
  }
}
